/**
 *
 * FreshPets Durations
 *
 */

const durations = ['0.15s', '0.3s', '0.45s', '0.6s']

export default durations
